function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9BADBC",
  fillRule: "evenodd",
  d: "M7 0a7.001 7.001 0 11-7 7.001C0 3.135 3.134.001 7 0zM3.964 9.21a.584.584 0 00.826.826l2.209-2.21L9.21 10.04a.584.584 0 00.825-.826L7.823 7.001l2.221-2.22a.584.584 0 00-.825-.826l-2.221 2.22L4.78 3.958a.584.584 0 00-.826.825l2.218 2.218-2.21 2.209z"
});

var SvgClearIcon = function SvgClearIcon(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgClearIcon;